import { call, put, takeLatest } from "redux-saga/effects"

import {
  POST_ADMIN_USER_LOGIN
} from "./actionTypes"

import {
  postAdminUserLoginSuccess,
  postAdminUserLoginError
} from "./actions"

import { postJwtLogin } from "helpers/sf_backend_helper.js"

import { AppConfiguration } from "config"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper"
import { LOGIN_AS_USER_KEY } from "helpers/sf_constants"
import { createAdminRecentVisit } from "../users/actions"
function* onAdminUserLogin({ payload: { user, history }, url_filter: url_filter }) {
  try {
    let adminUserInfo = bsh_getAdminUserDetails();
    let data = {
      ...user,
      token: adminUserInfo.token
    }
    const response = yield call(
      postJwtLogin,
      `${AppConfiguration.BACKEND_URL}/api/v1/login`,
      data
    )

    let authUser = { user: { token: response.data.token, account_id: response.data.memberships[0].account.id } }
    yield put(postAdminUserLoginSuccess(response.data));
    const hostParts = window.location.host.split('.');
    const newHost = hostParts.map(part => (part.includes(AppConfiguration.REACT_ADMIN_HOST_SUBDOMAIN)) ? AppConfiguration.REACT_CLIENT_HOST_SUBDOMAIN : part).join('.');
    //adding url filters which are then being used to redirect user to that client page after admin user logs in
    window.open(`http://${newHost}/login?${LOGIN_AS_USER_KEY.ADMIN_ACCESS}=true&${LOGIN_AS_USER_KEY.ACCESS_USER_TOKEN}=${JSON.stringify(authUser)}&${LOGIN_AS_USER_KEY.ACCESS_ADMIN_TOKEN}=${adminUserInfo.token}&url_filters=${url_filter}`, "_blank");
    yield put(createAdminRecentVisit({ account_id: response.data.memberships[0]?.account?.id }))
  } catch (error) {
    if (error) {
      history.push("/")
    }
    yield put(postAdminUserLoginError(error))
  }
}


function* adminUserLoginSaga() {
  yield takeLatest(POST_ADMIN_USER_LOGIN, onAdminUserLogin)
}

export default adminUserLoginSaga;
